// extracted by mini-css-extract-plugin
module.exports = {"border":"styles_border__JiZWH"};